<div id="register-organizational-audit" class="page-layout carded fullwidth inner-scroll data-list">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent-700"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <!-- HEADER -->
        <div class="header accent-700" fxLayout="row" fxLayoutAlign="center center" fxLayout.gt-sm="row"
            fxLayoutAlign.gt-sm="space-between center" fxLayoutAlign="space-between stretch">

            <!-- CRUD HEADER -->
            <crud-header [urlPath]="'Atendimento/Lançamento de Atendimento'" [header]="'list'"
                [mainName]="patient?.person?.name"></crud-header>

            <div fxLayout="row" fxLayoutAlign="start center" class="mt-md-0 header-button" fxHide fxShow.gt-md>
                <button matTooltip="voltar" id="backBtn" mat-stroked-button class="mr-12" (click)="back()"
                    [disabled]="loadingAction">
                    Voltar

                    <mat-icon *ngIf="!loadingAction">arrow_back</mat-icon>
                    <mat-spinner *ngIf="loadingAction" diameter="18"></mat-spinner>
                </button>

                <button *ngIf="patient" matTooltip="Editar paciente" id="edit" mat-stroked-button class="mr-12"
                    (click)="handlePatientEdit()" [disabled]="loadingAction">
                    Editar Paciente

                    <mat-icon *ngIf="!loadingAction">account_circle</mat-icon>
                    <mat-spinner *ngIf="loadingAction" diameter="18"></mat-spinner>
                </button>

                <button *ngIf="this.order?.id" matTooltip="Apagar OS" id="delet" mat-stroked-button class="mr-12"
                    (click)="osDelete(null, 'true')" [disabled]="loadingAction">
                    Apagar OS

                    <mat-icon *ngIf="!loadingAction">delete_forever</mat-icon>
                    <mat-spinner *ngIf="loadingAction" diameter="18"></mat-spinner>
                </button>

                <button *ngIf="this.isNewOs" [disabled]="disabledSaveAttendance == true || loadingAction"
                    matTooltip="Salvar" id="save-hd" mat-stroked-button class="mr-12" (click)="saveAttendane()">
                    Salvar

                    <mat-icon *ngIf="!loadingAction">backup</mat-icon>
                    <mat-spinner *ngIf="loadingAction" diameter="18"></mat-spinner>
                </button>

                <button *ngIf="patient" matTooltip="Novo" id="new" mat-stroked-button class="mr-12" (click)="newOrder()"
                    [disabled]="!patient?.active || loadingAction">
                    Nova OS

                    <mat-icon *ngIf="!loadingAction">add</mat-icon>
                    <mat-spinner *ngIf="loadingAction" diameter="18"></mat-spinner>
                </button>

                <button *ngIf="!blockGuide && patient && order && order.id && !pdfSrc" matTooltip="Guia"
                    mat-stroked-button class="mr-12" (click)="generateReport()" [disabled]="loadingAction">
                    Imprimir

                    <mat-icon *ngIf="!loadingAction">picture_as_pdf</mat-icon>
                    <mat-spinner *ngIf="loadingAction" diameter="18"></mat-spinner>
                </button>

                <button *ngIf="!blockReceipt && patient && order && order.id && !pdfSrc" matTooltip="Recibo"
                    mat-stroked-button [disabled]="order.insurance.paymentModel !== 'P' || loadingAction" class="mr-12"
                    (click)="generateReceipt(order.id)">
                    Recibo

                    <mat-icon *ngIf="!loadingAction">picture_as_pdf</mat-icon>
                    <mat-spinner *ngIf="loadingAction" diameter="18"></mat-spinner>
                </button>

                <button *ngIf="!blockGuide && patient && order && order.id" mat-stroked-button
                    [matMenuTriggerFor]="buttonsReport" [disabled]="loadingAction">
                    <mat-icon *ngIf="!loadingAction">menu</mat-icon>
                    <mat-spinner *ngIf="loadingAction" diameter="18"></mat-spinner>
                </button>
                <mat-menu #buttonsReport="matMenu">

                    <button *ngIf="patient && order  && order.id && !pdfSrc" title="Atestado" mat-menu-item
                        class="mr-12" (click)="openAttest()">
                        <mat-icon>receipt</mat-icon>
                        Atestado
                    </button>

                    <button *ngIf="!blockGuide && patient && order && order.id && !pdfSrc" mat-menu-item
                        (click)="generateReportOS(order.id)" [disabled]="loadingAction">
                        <mat-spinner *ngIf="loadingAction" diameter="18"></mat-spinner>
                        <mat-icon *ngIf="!loadingAction">picture_as_pdf</mat-icon>
                        OS
                    </button>

                    <button *ngIf="!blockGuide && patient && order && order.id && !pdfSrc" title="Folha de Laudo"
                        mat-menu-item (click)="generateReportSheetOS(order.id)">
                        <mat-icon>picture_as_pdf</mat-icon>
                        Folha de Laudo
                    </button>

                    <button *ngIf="!blockGuide && patient && order && order.id && !pdfSrc" title="Protocolo de entrega"
                        mat-menu-item (click)="generateReportProtocolDelivery(order.id)">
                        <mat-icon>picture_as_pdf</mat-icon>
                        Protocolo de entrega
                    </button>

                </mat-menu>

            </div>

            <button fxHide.gt-md mat-button [matMenuTriggerFor]="teste"><mat-icon>menu</mat-icon></button>
            <mat-menu #teste="matMenu">
                <button mat-menu-item matTooltip="voltar" id="backBtn" class="mr-12" (click)="back()">
                    <mat-icon>arrow_back</mat-icon>
                    <span>Voltar</span>
                </button>
                <button mat-menu-item *ngIf="patient" matTooltip="Editar paciente" id="edit" class=" mr-12"
                    (click)="handlePatientEdit()">
                    <mat-icon>account_circle</mat-icon>
                    <span>Cadastro paciente</span>
                    <!-- <span class="material-icons"></span> -->
                </button>
                <button mat-menu-item *ngIf="this.order?.id" matTooltip="Apagar OS" id="delet" class=" mr-12"
                    (click)="osDelete(null, 'true')">
                    <mat-icon>delete_forever</mat-icon>
                    <span>Apagar</span>
                </button>
                <button mat-menu-item *ngIf="this.isNewOs" [disabled]="disabledSaveAttendance" matTooltip="Salvar"
                    id="save-mobile" class="mr-12" (click)="saveAttendane()">
                    <mat-icon>backup</mat-icon>
                    <span>Salvar</span>
                </button>
                <button mat-menu-item *ngIf="patient" matTooltip="Novo" id="new" class="mr-12" (click)="newOrder()"
                    [disabled]="!patient?.active">
                    <mat-icon>add</mat-icon>
                    <span>Novo</span>
                </button>
                <button mat-menu-item *ngIf="patient && order  && order.id && !pdfSrc" matTooltip="Guia" class="mr-12"
                    (click)="generateReport()">
                    <mat-icon>picture_as_pdf</mat-icon>
                    <span>Imprimir</span>
                </button>

                <button mat-menu-item *ngIf="patient && order  && order.id && !pdfSrc" matTooltip="Guia"
                    [disabled]="order.insurance.paymentModel !== 'P'" class="mr-12" (click)="generateReceipt(order.id)">
                    <mat-icon>picture_as_pdf</mat-icon>
                    <span>Recibo</span>
                </button>

                <button mat-menu-item *ngIf="patient && order  && order.id && !pdfSrc" matTooltip="Guia"
                    (click)="generateReportOS(order.id)">
                    <mat-icon>picture_as_pdf</mat-icon>
                    <span>Guia OS</span>
                </button>
            </mat-menu>

        </div>

        <!--pdf-viewer *ngIf="pdfSrc" [src]="pdfSrc" [render-text]="true" style="display: block;" [autoresize]="true"></pdf-viewer-->


        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <div class="content">
                <div class="tab-content p-24" fusePerfectScrollbar>

                    <!-- <div class="content" *ngIf="loading" fxLayoutAlign="center center">
                <mat-spinner></mat-spinner>
            </div> -->

                    <form [formGroup]="osForm" autocomplete="off">
                        <!--   <div fxLayout="row" class="w-100-p">
                     <div fxLayout="column" class="w-85-p">-->

                        <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">

                            <mat-form-field appearance="outline" fxFlex="30" class="mr-8">
                                <mat-label>Paciente</mat-label>
                                <input formControlName="patient" matInput autocomplete="off" type="search" readonly>
                                <mat-hint *ngIf="patient?.person?.isBirthday"
                                    style="color: red;"><b>ANIVERSARIANTE</b></mat-hint>
                                <mat-error *ngIf="osForm.get('patient').hasError('required')">
                                    Campo obrigatório
                                </mat-error>
                                <mat-error *ngIf="osForm.get('patient').hasError('incorrect')">
                                    Selecione um usuário válido
                                </mat-error>

                            </mat-form-field>

                            <mat-form-field fxFlex="30" class="mr-8" appearance="outline">
                                <mat-label>Convênio</mat-label>
                                <input matInput [value]="osForm.controls['insurance']?.value?.name" autocomplete="off"
                                    type="search" readonly />
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="10" class="mr-8">
                                <mat-label>Matrícula</mat-label>
                                <input matInput name="registration" formControlName="registration"
                                    [mask]="maskRegistration">
                                <mat-error *ngIf="osForm.get('registration').hasError('required')">
                                    Campo é obrigatório
                                </mat-error>
                            </mat-form-field>



                            <mat-form-field appearance="outline" fxFlex="10" class="mr-8">
                                <mat-label>Plano</mat-label>
                                <input matInput [matAutocomplete]="patientPlan" formControlName="plan"
                                    autocomplete="off" type="search" />
                                <mat-autocomplete autoActiveFirstOption #patientPlan="matAutocomplete"
                                    autoActiveFirstOption [displayWith]="displaySimpleFn">
                                    <mat-option *ngFor="let plan of patientPlanList" [value]="plan">
                                        {{plan?.name || ''}}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="osForm.get('plan').hasError('required')">
                                    Campo é obrigatório
                                </mat-error>
                            </mat-form-field>

                            <!-- <mat-form-field appearance="outline" fxFlex="30" class="mr-8 hidden">
                        <mat-label>Titular</mat-label>
                        <input matInput name="holder" formControlName="holder">
                        <mat-error *ngIf="osForm.get('holder').hasError('required')">
                            Campo é obrigatório
                        </mat-error>
                    </mat-form-field> -->

                            <!-- <mat-form-field appearance="outline" fxFlex="10" class="mr-8">
                        <mat-label>Produto *</mat-label>
                        <input matInput name="product" formControlName="product">
                        <mat-error *ngIf="osForm.get('product').hasError('required')">
                            Campo é obrigatório
                        </mat-error>
                    </mat-form-field> -->

                            <mat-form-field appearance="outline" fxFlex="15" class="mr-8">
                                <mat-label>Validade</mat-label>
                                <input autocomplete="off" matInput [matDatepicker]="validity" placeholder="Validade"
                                    formControlName="validity" />
                                <mat-datepicker-toggle id="validity" matSuffix [for]="validity">
                                </mat-datepicker-toggle>
                                <mat-datepicker #validity></mat-datepicker>
                            </mat-form-field>


                        </div>

                        <br *ngIf="patient?.person?.isBirthday">

                        <div [ngClass]="{ contactBoxHidden: !hideFormPatient, contactBox: hideFormPatient }"
                            class="w-100-p">
                            <h1>
                                <span class="mr-12 ml-12">
                                    <b class="title">Detalhes do Paciente</b>
                                    <button id="search-web-contact" class="mr-8" mat-icon-button
                                        aria-label="Mostrar/ocultar informações paciente" (click)="changeViewMode()">
                                        <mat-icon *ngIf="hideFormPatient">visibility_off</mat-icon>
                                        <mat-icon *ngIf="!hideFormPatient"> visibility</mat-icon>
                                    </button>
                                    <!-- <button id="search-web-contact" class="mr-8" matTooltip="Limpar contato" mat-icon-button mat-raised-button
                                aria-label="Buscar endereço" (click)="cleanContact()">
                                <mat-icon>close</mat-icon>
                            </button> -->
                                </span>
                            </h1>
                            <div fxLayout="row" *ngIf="hideFormPatient">

                                <div fxLayout="column" class="w-90-p mr-12">
                                    <div fxLayout="row">

                                        <mat-form-field appearance="outline" fxFlex="30" class="mr-8 ml-8">
                                            <mat-label>CPF</mat-label>
                                            <input matInput name="cpf" formControlName="cpf">
                                            <mat-error *ngIf="osForm.get('cpf').hasError('required')">
                                                Campo é obrigatório
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" fxFlex="30" class="mr-8">
                                            <mat-label>CNS</mat-label>
                                            <input matInput name="cns" formControlName="cns" readonly>
                                            <mat-error *ngIf="osForm.get('cns').hasError('required')">
                                                Campo é obrigatório
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" fxFlex="15" class="mr-8">
                                            <mat-label>Nascimento</mat-label>
                                            <input autocomplete="off" matInput [matDatepicker]="birthday"
                                                placeholder="Nascimento" formControlName="birthday" />
                                            <mat-datepicker-toggle id="birthday" matSuffix [for]="birthday">
                                            </mat-datepicker-toggle>
                                            <mat-datepicker #birthday></mat-datepicker>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" fxFlex="30" class="mr-8">
                                            <mat-label>Genero</mat-label>
                                            <input matInput name="gender" formControlName="gender">
                                            <mat-error *ngIf="osForm.get('gender').hasError('required')">
                                                Campo é obrigatório
                                            </mat-error>
                                        </mat-form-field>




                                    </div>

                                    <div fxLayout="row">

                                        <mat-form-field appearance="outline" fxFlex="30" class="mr-8 ml-8">
                                            <mat-label>Prontuário</mat-label>
                                            <input matInput name="medicalRecord" formControlName="medicalRecord"
                                                readonly>
                                            <mat-error *ngIf="osForm.get('medicalRecord').hasError('required')">
                                                Campo é obrigatório
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" fxFlex="30" class="mr-8">
                                            <mat-label>E-mail</mat-label>
                                            <input matInput name="email" formControlName="email" readonly>
                                            <mat-error *ngIf="osForm.get('email').hasError('required')">
                                                Campo é obrigatório
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" fxFlex="30" class="mr-8">
                                            <mat-label>Telefone</mat-label>
                                            <input matInput name="tel" formControlName="tel" readonly
                                                mask="(00) 0000-0000||(00) 0 0000-0000">
                                            <mat-error *ngIf="osForm.get('tel').hasError('required')">
                                                Campo é obrigatório
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" fxFlex="30" class="mr-8">
                                            <mat-label>Cidade</mat-label>
                                            <input matInput name="city" formControlName="city" readonly>
                                            <mat-error *ngIf="osForm.get('city').hasError('required')">
                                                Campo é obrigatório
                                            </mat-error>
                                        </mat-form-field>


                                    </div>
                                </div>
                                <div fxLayout="column">
                                    <div *ngIf="imagePath" fxFlex="10">
                                        <img [src]="imagePath"
                                            style="width: 100px; height: 100px; border-radius: 50%;" />
                                    </div>
                                </div>


                            </div>
                            <!--  </div> 
                    {{ lockCheck.value
                                                == true ? 'Bloqueada' : 'Bloqueada' }}-->
                            <!--   </div> -->

                        </div>
                    </form>
                    <div fxLayout="row" fxLayoutGap="5" fxLayoutAlign="space-between center" class="row_buttons"
                        *ngIf="order?.id">
                        <div fxLayoutGap="5">
                            <button id="operational-reception-os-cancel-edit-form_bt" mat-raised-button
                                (click)="lockOrUnlockOrCancelOrder('CANCEL')" style="color: #ba2800"
                                *ngIf="order.state != 'C'"
                                [disabled]="isAdvancePaymentOrder"><mat-icon>not_interested</mat-icon> Cancelar
                                Guia</button>
                            <button id="operational-reception-os-advance-payment-edit-form_bt" mat-raised-button
                                (click)="goToAdvancePayment()" style="color: #00A5BA"
                                *ngIf="advancePaymentBudgetId"><mat-icon>payments</mat-icon> Pagamento
                                Antecipado</button>
                            <button id="operational-reception-os-cancel-edit-form_bt" mat-raised-button
                                (click)="lockOrUnlockOrCancelOrder('UNCANCEL')" style="color: #ba2800"
                                *ngIf="order.state == 'C'"><mat-icon>check_circle</mat-icon> Desfazer Cancelamento da
                                Guia</button>
                            <button id="operational-reception-os-lock-edit-form_bt" mat-raised-button
                                (click)="lockOrUnlockOrCancelOrder('UNLOCK')" style="color: #00A5BA"
                                *ngIf="lockCheck.value == true"><mat-icon>lock</mat-icon> Desbloquear </button>
                            <button id="operational-reception-os-lock-edit-form_bt" mat-raised-button
                                (click)="lockOrUnlockOrCancelOrder('LOCK')" style="color: #ba2800"
                                *ngIf="lockCheck.value == false"><mat-icon>un_lock</mat-icon> Bloquear </button>

                            <button id="operational-reception-os-close-edit-form_bt"
                                (click)="lockOrUnlockOrCancelOrder('CLOSE')" *ngIf="orderStatus === 'Aberta'"
                                mat-raised-button><mat-icon>lock</mat-icon> Fechar Guia</button>

                            <button id="operational-reception-os-open-edit-form_bt"
                                (click)="lockOrUnlockOrCancelOrder('OPEN')" *ngIf="orderStatus === 'Fechada'"
                                mat-raised-button><mat-icon>un_lock</mat-icon> Abrir
                                Guia</button>

                        </div>
                        <div fxLayout="row">

                            <h1 [ngStyle]="{'background-color':stateColor}" class="infoStatus">{{this.orderState}}</h1>
                            <h1 style="background-color:#00A5BA" class="infoStatus">{{orderStatus}}</h1>
                        </div>
                    </div>
                    <!-- <section @fadeInLeft> -->
                    <section>


                        <div class="container">
                            <mat-tab-group (selectedTabChange)="changeViewByTab($event.index)" mat-stretch-tabs
                                [selectedIndex]="selectedTabIndex">


                                <mat-tab label="Histórico">
                                    <ng-template mat-tab-label>
                                        <mat-icon class="mr-8">history</mat-icon>
                                        Histórico
                                    </ng-template>

                                    <ng-template matTabContent>

                                        <cw-os-history *ngIf="this.patient?.id"
                                            [patientId]="this.patient.id"></cw-os-history>
                                    </ng-template>


                                </mat-tab>

                                <mat-tab label="OS" [disabled]="isNewOs == false">
                                    <ng-template mat-tab-label>
                                        <mat-icon class="mr-8">receipt_long</mat-icon>
                                        OS

                                    </ng-template>

                                    <button mat-button fxLayout="row" fxLayoutAlign="center"
                                        *ngIf="loadingOs || loading">

                                        <div fxLayoutAlign="space-evenly center">
                                            <mat-spinner [diameter]="20" class="mr-8"></mat-spinner>
                                            <p>Processando, aguarde...</p>
                                        </div>
                                    </button>

                                    <section class="mt-20" *ngIf="isNewOs && !loadingOs">

                                        <form [formGroup]="osHeaderForm" fxLayout="column"
                                            style="display: block!important;" autocomplete="off" id="osHeaderForm"
                                            *ngIf="!loadingOs">
                                            
                                            <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="20px"
                                                fxLayoutGap.lt-md="0px">

                                                <mat-form-field appearance="outline" fxFlex="11" fxFlex.lt-md="100"
                                                    class="mr-8">
                                                    <mat-label>Número da guia</mat-label>
                                                    <input matInput name="numberOs" formControlName="numberHeaderOs">
                                                    <button matSuffix mat-icon-button aria-label="New Guide"
                                                        matTooltip="Gerar novo número de guia"
                                                        title="Gerar novo número de guia"
                                                        *ngIf="order?.id && order.status == '1'"
                                                        (click)="generateNewNumberOrder()">
                                                        <mat-icon>sync</mat-icon>
                                                    </button>
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" fxFlex="8" class="mr-8">
                                                    <mat-label>Data</mat-label>
                                                    <input autocomplete="off" [(ngModel)]="osDate" matInput
                                                        [matDatepicker]="dateOs" placeholder="Data"
                                                        formControlName="dateHeaderOs" required
                                                        [readonly]="this.order.id" />
                                                    <mat-datepicker-toggle id="dateInitPicker" matSuffix [for]="dateOs">
                                                    </mat-datepicker-toggle>
                                                    <mat-datepicker #dateOs></mat-datepicker>
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" fxFlex="7" class="mr-8">
                                                    <mat-label>Hora</mat-label>
                                                    <input matInput name="hourHeaderOs" required
                                                        formControlName="hourHeaderOs" type="time"
                                                        [readonly]="this.order.id">

                                                </mat-form-field>

                                                <mat-form-field appearance="outline" fxFlex="15" class="mr-12">
                                                    <mat-label>Tipo de Atendimento</mat-label>
                                                    <input matInput [matAutocomplete]="autoExameType"
                                                        formControlName="attendanceTypeHeaderOs" autocomplete="off"
                                                        type="search" />
                                                    <mat-autocomplete autoActiveFirstOption
                                                        #autoExameType="matAutocomplete" autoActiveFirstOption
                                                        [displayWith]="displaySimpleFn"
                                                        (optionSelected)="setExameType($event.option.value)">
                                                        <mat-option *ngFor="let exameType of typeSurveyList"
                                                            [value]="exameType">
                                                            {{exameType.name}}
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field>

                                                <!-- //Retirado do convenio pra testes -->
                                                <!-- (optionSelected)="getProcedurePerfomerByInsurance($event.option.value)" -->
                                                <mat-form-field fxFlex="30" class="mr-12" appearance="outline">
                                                    <mat-label>Convênio</mat-label>
                                                    <input matInput [matAutocomplete]="autoInsuranceF"
                                                        formControlName="insuranceHeaderOs" autocomplete="off"
                                                        type="search" [readonly]="this.order.id" />
                                                    <button
                                                        *ngIf="this.osHeaderForm.controls.insuranceHeaderOs.value && !this.order.id"
                                                        matSuffix mat-icon-button aria-label="Clear"
                                                        (click)="this.osHeaderForm.controls['insuranceHeaderOs'].setValue('')">
                                                        <mat-icon>close</mat-icon>
                                                    </button>

                                                    <button *ngIf="order.id" matSuffix mat-icon-button
                                                        aria-label="Clear" title="Alterar Convênio"
                                                        [disabled]="isAdvancePaymentOrder"
                                                        (click)="updateInsuranceInOrder()">
                                                        <mat-icon>swap_vert</mat-icon>
                                                    </button>
                                                    <mat-autocomplete autoActiveFirstOption
                                                        #autoInsuranceF="matAutocomplete" autoActiveFirstOption
                                                        [displayWith]="displaySimpleFn">
                                                        <mat-option *ngFor="
                                        let insurance of insuranceList
                                    " [value]="insurance">
                                                            <p *ngIf="insurance">
                                                                {{ insurance.name }}
                                                            </p>
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                    <mat-error *ngIf="osForm.get('insurance').hasError('required')">
                                                        Campo é obrigatório
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" fxFlex="8" class="mr-12">
                                                    <mat-label>Plano</mat-label>
                                                    <input matInput [matAutocomplete]="autoPlan"
                                                        formControlName="planHeaderOs" autocomplete="off"
                                                        type="search" />
                                                    <mat-autocomplete autoActiveFirstOption #autoPlan="matAutocomplete"
                                                        autoActiveFirstOption [displayWith]="displaySimpleFn"
                                                        (optionSelected)="setMainPlan($event.option.value)">
                                                        <mat-option *ngFor="let plan of planList" [value]="plan">
                                                            {{plan.name}}
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" fxFlex="" class="mr-8">
                                                    <mat-label>Matrícula</mat-label>
                                                    <button matSuffix (click)="verifyEligibility()"
                                                        *ngIf="userWebserviceSulAmerica"
                                                        [disabled]="loadingverifyEligibility"
                                                        title="Verificar Elegibilidade" mat-icon-button
                                                        style="color: #1e527f;">
                                                        <mat-spinner *ngIf="loadingverifyEligibility" diameter="20"
                                                            class="mr-8"></mat-spinner>
                                                        <mat-icon
                                                            *ngIf="!loadingverifyEligibility">find_in_page</mat-icon>
                                                    </button>
                                                    <button *ngIf="order.id" matSuffix mat-icon-button
                                                        aria-label="Clear" title="Atualizar Matricula no Cadastro"
                                                        (click)="updateEnrollmentPatient()">
                                                        <mat-icon>refresh</mat-icon>
                                                    </button>
                                                    <input id="operational-reception-os-enrollment-edit-form_it"
                                                        matInput name="registration" formControlName="enrollment"
                                                        [mask]="maskRegistration">
                                                    <mat-error
                                                        *ngIf="osHeaderForm.get('enrollment').hasError('required')">
                                                        Campo é obrigatório
                                                    </mat-error>
                                                </mat-form-field>



                                                <!-- 
                                        <mat-form-field appearance="outline" class="w-20-p mr-12">
                                            <mat-label>Tipo de Lançamento</mat-label>
                                            <mat-select matInput formControlName="typeHeaderOs">
                                                <mat-option value="1">Procedimento</mat-option>
                                                <mat-option value="2">Material</mat-option>
                                                <mat-option value="3">Medicamento</mat-option>
                                                <mat-option value="4">Outros Produtos</mat-option>
                                            </mat-select>
                                        </mat-form-field> -->






                                            </div>
                                            <div fxLayout="row" class="w-100-p" fxFlexAlign="center">

                                                <mat-form-field *ngIf="!order.id" appearance="outline" class="mr-12">
                                                    <mat-label>Quantidade</mat-label>
                                                    <input matInput placeholder="Quantidade" type="number"
                                                        formControlName="quantity">
                                                </mat-form-field>


                                                <mat-form-field appearance="outline" fxFlex="60" class="mr-12">
                                                    <mat-label>Item Principal</mat-label>
                                                    <input matInput [matAutocomplete]="autoProcedureF" id="item-main"
                                                        cwgAutoFocusDirective time="1000"
                                                        formControlName="mainItemHeaderOs" autocomplete="off"
                                                        type="search" [readonly]="this.order.id" />
                                                    <mat-error
                                                        *ngIf="osHeaderForm.get('mainItemHeaderOs').hasError('incorrect')">
                                                        Serviço inválido
                                                    </mat-error>
                                                    <mat-autocomplete autoActiveFirstOption
                                                        #autoProcedureF="matAutocomplete" autoActiveFirstOption
                                                        [displayWith]="displaySimpleFn"
                                                        (optionSelected)="handleProceduleSelected($event.option.value.id,$event.option.value.accreditationId )">
                                                        <mat-option *ngFor="let procedure of procedureList"
                                                            [value]="procedure" style="height: auto;">
                                                            <div class="space">
                                                                <p>{{ procedure.name }}</p>
                                                                <p>Código: {{procedure.code }} </p>
                                                            </div>

                                                            <mat-divider></mat-divider>

                                                        </mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" class="mr-12" fxFlex="60">
                                                    <mat-label>Profissional Principal</mat-label>
                                                    <input matInput [matAutocomplete]="autoPerformerF"
                                                        formControlName="mainProfessionalHeaderOs" autocomplete="off"
                                                        type="search" [readonly]="this.order.id" />
                                                    <button
                                                        *ngIf="this.osHeaderForm.controls.mainProfessionalHeaderOs.value && !this.order.id"
                                                        matSuffix mat-icon-button aria-label="Clear"
                                                        (click)="this.osHeaderForm.controls['mainProfessionalHeaderOs'].setValue('')">
                                                        <mat-icon>close</mat-icon>
                                                    </button>
                                                    <mat-autocomplete autoActiveFirstOption
                                                        #autoPerformerF="matAutocomplete" autoActiveFirstOption
                                                        [displayWith]="displayPerformerFn">
                                                        <mat-option *ngFor="
                                                    let performer of performerList
                                                " [value]="performer">
                                                            <p *ngIf="performer">
                                                                {{ performer.professional.person.name }}
                                                            </p>
                                                        </mat-option>
                                                    </mat-autocomplete>

                                                </mat-form-field>

                                                <mat-form-field *ngIf="!order.id" appearance="outline"
                                                    class="w-45-p mr-12">
                                                    <mat-label>Especialidade</mat-label>
                                                    <input matInput type="search" autocomplete="off"
                                                        [matAutocomplete]="auto" [formControl]="specialityControl"
                                                        placeholder="Nome">
                                                    <mat-error *ngIf="specialityControl.hasError('incorrect')">
                                                        Especialidade inválida
                                                    </mat-error>
                                                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                                                        id="register-organizational-professional-person-speciality-edit-form_ac"
                                                        [displayWith]="displayGenericFn"
                                                        (optionSelected)='setSpeciality($event.option.value)'>
                                                        <mat-option *ngFor="let speciality of specialityList"
                                                            [value]="speciality">
                                                            {{speciality?.name}}
                                                        </mat-option>

                                                    </mat-autocomplete>
                                                </mat-form-field>

                                            </div>

                                            <div fxLayout="row wrap" fxFlex="100">

                                                <mat-form-field appearance="outline" fxFlex="20" class="mr-12"
                                                    id="operational-reception-os-company-edit-form_ac">
                                                    <mat-label>Empresa</mat-label>
                                                    <input matInput [matAutocomplete]="autoCompany"
                                                        [formControl]="companyControl" placeholder="Unidade"
                                                        type="search" [readonly]="this.order.status == '2'">
                                                    <mat-autocomplete autoActiveFirstOption
                                                        #autoCompany="matAutocomplete"
                                                        (optionSelected)="getCompanyCostCenter($event.option.value)"
                                                        [displayWith]="displayCompanyFn">
                                                        <mat-option *ngFor="let company of companyList"
                                                            [value]="company">
                                                            {{company?.alias}}
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" class="mr-12" fxFlex="20"
                                                    id="operational-reception-os-resultCenterHeaderOs-edit-form_ac">
                                                    <mat-label>Centro de Resultado</mat-label>
                                                    <input matInput name="resultCenterHeaderOs" required
                                                        formControlName="resultCenterHeaderOs"
                                                        [matAutocomplete]="autoCenterResult" autocomplete="off"
                                                        type="search" [readonly]="this.order.status == '2'">
                                                    <mat-autocomplete autoActiveFirstOption
                                                        #autoCenterResult="matAutocomplete" autoActiveFirstOption
                                                        [displayWith]="displayCompanyCostCenterFn"
                                                        (optionSelected)="setMainCostCenter($event.option.value)">
                                                        <mat-option
                                                            *ngFor="let companyCostCenter of companyCostCenterList"
                                                            [value]="companyCostCenter">
                                                            <p *ngIf="companyCostCenter">
                                                                {{ companyCostCenter.costCenter.name }}
                                                            </p>
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field>

                                                <!-- <mat-form-field appearance="outline" class="mr-12" fxFlex="15">
                                            <mat-label>Status</mat-label>
                                            <mat-select id="operational-reception-os-statusHeaderOs-edit-form_cs"
                                                matInput formControlName="statusHeaderOs">
                                                <mat-option value="1">Aberta</mat-option>
                                                <mat-option value="2">Fechada</mat-option>
                                            </mat-select>
                                        </mat-form-field> -->


                                                <mat-form-field appearance="outline" class="mr-12" fxFlex="10">
                                                    <mat-label>Valor total</mat-label>
                                                    <input matInput placeholder="Total" (dblclick)="memoryCalc()"
                                                        [readonly]="useAccreditationValue == true || order?.id"
                                                        formControlName="value" currencyMask
                                                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2}">
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" *ngIf="order?.id" class="mr-12"
                                                    fxFlex="10">
                                                    <mat-label>Dt. Fatura</mat-label>
                                                    <input matInput [formControl]="dateBillingControl"
                                                        readonly="readonly">
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" *ngIf="order?.id" class="mr-12"
                                                    fxFlex="5">
                                                    <mat-label>Lote</mat-label>
                                                    <input matInput [formControl]="coverBillingControl"
                                                        readonly="readonly">
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" *ngIf="order?.id" class="mr-12"
                                                    fxFlex="10">
                                                    <mat-label>Dt Pagamento</mat-label>
                                                    <input matInput [formControl]="datePayControl" readonly="readonly">
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" *ngIf="order?.id" class="mr-12"
                                                    fxFlex="10">
                                                    <mat-label>N. repasse</mat-label>
                                                    <input matInput [formControl]="repasseControl" readonly="readonly">
                                                </mat-form-field>
                                                <mat-form-field appearance="outline" *ngIf="order?.id" class="mr-12"
                                                    fxFlex="8">
                                                    <mat-label>Lançado por: </mat-label>
                                                    <input matInput [formControl]="userCreatedControl"
                                                        readonly="readonly">
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" *ngIf="order?.id" class="mr-12"
                                                    fxFlex="8">
                                                    <mat-label>Atualizado por: </mat-label>
                                                    <input matInput [formControl]="userUpdatedControl"
                                                        readonly="readonly">
                                                </mat-form-field>

                                                <!-- <mat-form-field appearance="outline" fxFlex="30" class="mr-8"
                                            *ngIf="!this.order?.id">
                                            <mat-label>Profissonal Solicitante</mat-label>

                                            <input matInput name="profissionalRequest" required
                                                [formControl]="professionalSolicControl"
                                                [matAutocomplete]="autoProfissionalRequest" autocomplete="off"
                                                type="search" />

                                            <button matSuffix mat-icon-button aria-label="Clear"
                                                title="Cadastro de Solicitante" (click)="registrationSolic()">
                                                <mat-icon>add</mat-icon>
                                            </button>

                                            <mat-autocomplete autoActiveFirstOption
                                                #autoProfissionalRequest="matAutocomplete" autoActiveFirstOption
                                                [displayWith]="displayPerformerFn">
                                                <mat-option *ngFor="let professional of profissionalList"
                                                    [value]="professional" style="height: auto;">
                                                    <div class="space">
                                                        <p>{{ professional.person.name }}</p>
                                                        <p>N. Conselho: {{ professional.councilNumber }} </p>
                                                        <p>Tipo: {{ professional.staff ? 'Interno' : 'Externo' }} </p>
                                                    </div>

                                                    <mat-divider></mat-divider>

                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" fxFlex="10" *ngIf="!this.order?.id">
                                            <mat-label>UF</mat-label>
                                            <input matInput name="UF" readonly
                                                [value]="professionalSolicControl?.value?.state?.initials" />
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="w-15-p mr-8"
                                            *ngIf="!this.order?.id">
                                            <mat-label>Número do Conselho</mat-label>
                                            <input matInput name="numeroConselho" readonly
                                                [value]="professionalSolicControl?.value?.councilNumber" />
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="w-15-p mr-8"
                                            *ngIf="!this.order?.id">
                                            <mat-label>Tipo do solicitante</mat-label>
                                            <input matInput name="tipoSolicitante"
                                                [formControl]="typeProfessionalSolicControl" readonly
                                                [value]="tipoSolicitante" />
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" fxFlex="20" class="mr-8"
                                            *ngIf="!this.order?.id" id="operational-reception-os-firm-edit-form_ac">
                                            <mat-label>Empresa Solicitante</mat-label>

                                            <input matInput name="autoFirmRequest" [formControl]="firmSolicControl"
                                                [matAutocomplete]="autoFirmRequest" autocomplete="off" type="search" />

                                            <button matSuffix mat-icon-button aria-label="Clear"
                                                title="Cadastro de Solicitante" (click)="registrationFirm()">
                                                <mat-icon>add</mat-icon>
                                            </button>

                                            <mat-autocomplete autoActiveFirstOption #autoFirmRequest="matAutocomplete"
                                                autoActiveFirstOption [displayWith]="displayFirmFn">
                                                <mat-option *ngFor="let firm of firmList" [value]="firm"
                                                    style="height: auto !important;">
                                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                                        {{ firm.name }}
                                                    </div>
                                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                                        <span><b>Inscrição:</b> {{ firm.registry }}</span>
                                                    </div>
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field> -->

                                                <!-- <section fxLayoutAlign="center center" style="margin-bottom: 21px !important;">
                                            <mat-checkbox [formControl]="lockCheck" color="primary">{{ lockCheck.value
                                                == true ? 'Bloqueada' : 'Bloqueada' }}</mat-checkbox>
                                          <mat-slide-toggle [formControl]="lockCheck">
                                                {{ lockCheck.value == true ? 'Bloqueada' : 'Bloqueada' }}
                                            </mat-slide-toggle> 
                                        </section> -->


                                            </div>
                                            <div fxLayout="row">
                                                <mat-form-field appearance="outline" fxFlex="30" class="mr-8"
                                                    *ngIf="!this.order?.id">
                                                    <mat-label>Profissonal Solicitante</mat-label>

                                                    <input matInput name="profissionalRequest" required
                                                        [formControl]="professionalSolicControl"
                                                        [matAutocomplete]="autoProfissionalRequest" autocomplete="off"
                                                        type="search" />

                                                    <button matSuffix mat-icon-button aria-label="Clear"
                                                        title="Cadastro de Solicitante" (click)="registrationSolic()">
                                                        <mat-icon>add</mat-icon>
                                                    </button>

                                                    <mat-autocomplete autoActiveFirstOption
                                                        #autoProfissionalRequest="matAutocomplete" autoActiveFirstOption
                                                        [displayWith]="displayPerformerFn">
                                                        <mat-option *ngFor="let professional of profissionalList"
                                                            [value]="professional" style="height: auto;">
                                                            <div class="space">
                                                                <p>{{ professional.person.name }}</p>
                                                                <p>N. Conselho: {{ professional.councilNumber }} </p>
                                                                <p>Tipo: {{ professional.staff ? 'Interno' : 'Externo'
                                                                    }} </p>
                                                            </div>

                                                            <mat-divider></mat-divider>

                                                        </mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" fxFlex="10" *ngIf="!this.order?.id"
                                                    class="w-15-p mr-8">
                                                    <mat-label>UF</mat-label>
                                                    <input matInput name="UF" readonly
                                                        [value]="professionalSolicControl?.value?.state?.initials" />
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" class="w-15-p mr-8"
                                                    *ngIf="!this.order?.id">
                                                    <mat-label>Número do Conselho</mat-label>
                                                    <input matInput name="numeroConselho" readonly
                                                        [value]="professionalSolicControl?.value?.councilNumber" />
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" class="w-15-p mr-8"
                                                    *ngIf="!this.order?.id">
                                                    <mat-label>Tipo do solicitante</mat-label>
                                                    <input matInput name="tipoSolicitante"
                                                        [formControl]="typeProfessionalSolicControl" readonly
                                                        [value]="tipoSolicitante" />
                                                </mat-form-field>

                                                <mat-form-field appearance="outline" fxFlex="20" class="mr-8"
                                                    *ngIf="!this.order?.id"
                                                    id="operational-reception-os-firm-edit-form_ac">
                                                    <mat-label>Empresa Solicitante</mat-label>

                                                    <input matInput name="autoFirmRequest"
                                                        [formControl]="firmSolicControl"
                                                        [matAutocomplete]="autoFirmRequest" autocomplete="off"
                                                        type="search" />

                                                    <button matSuffix mat-icon-button aria-label="Clear"
                                                        title="Cadastro de Solicitante" (click)="registrationFirm()">
                                                        <mat-icon>add</mat-icon>
                                                    </button>

                                                    <mat-autocomplete autoActiveFirstOption
                                                        #autoFirmRequest="matAutocomplete" autoActiveFirstOption
                                                        [displayWith]="displayFirmFn">
                                                        <mat-option *ngFor="let firm of firmList" [value]="firm"
                                                            style="height: auto !important;">
                                                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                                                {{ firm.name }}
                                                            </div>
                                                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                                                <span><b>Inscrição:</b> {{ firm.registry }}</span>
                                                            </div>
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field>
                                            </div>
                                            <div fxLayout="row" class="w-100-p">

                                                <mat-form-field appearance="outline" fxFlex="100">
                                                    <mat-label>Cids</mat-label>
                                                    <mat-chip-list #chipList aria-label="Cid selection">
                                                        <mat-chip
                                                            [ngStyle]=" cid.main ? {'background-color':'#00bcd4'}: ''"
                                                            *ngFor="let cid of cidListSelected"
                                                            (removed)="cidRemove(cid)" (dblclick)="cidMain(cid)">
                                                            {{cid.cid.name}} | {{cid.cid.code}}
                                                            <mat-icon matChipRemove>cancel</mat-icon>
                                                        </mat-chip>
                                                        <input placeholder="Selecione..." #cidInput
                                                            [formControl]="cidFormControl" [matAutocomplete]="auto"
                                                            [matChipInputFor]="chipList">
                                                    </mat-chip-list>
                                                    <mat-autocomplete #auto="matAutocomplete"
                                                        (optionSelected)="cidSelected($event)">
                                                        <mat-option *ngFor="let cid of CIDList" [value]="cid">
                                                            {{cid.name}} | {{cid.code}}
                                                        </mat-option>
                                                    </mat-autocomplete>
                                                </mat-form-field>
                                            </div>
                                            <h3 *ngIf="sessionView">Informações de sessão</h3>
                                            <div *ngIf="sessionView" fxLayout="row" fxFlex="100">
                                                <cw-sessionLaunch fxFlex="100" [iOrder]="order"
                                                    [iserviceFrequencyPerWeek]="serviceFrequencyPerWeek"
                                                    [iProcedure]="osHeaderForm.controls.mainItemHeaderOs.value?.id"
                                                    [iQuantSessionCurrent]="quatitySessionCurrent" [iContext]="'ORDER'"
                                                    [iServiceDate]="osHeaderForm.controls.dateHeaderOs?.value"
                                                    (oSession)="getSession($event)"></cw-sessionLaunch>
                                            </div>

                                        </form>
                                        <div fxLayout="row" *ngIf="!order?.id">
                                            <cwg-attendance-material #attendanceMaterial fxFlex="100"
                                                [hidden]="order?.id || loadingOs"
                                                (oFeeKitList)="setKitList($event, 'F')"
                                                (oDrugKitList)="setKitList($event,'D')"
                                                (oMaterialKitList)="setKitList($event,'M')"
                                                (oAuxiliaryKitList)="setKitList($event, 'A')"
                                                (oOpmeKitList)="setKitList($event, 'O')">
                                            </cwg-attendance-material>
                                        </div>
                                    </section>

                                    <section *ngIf="this.order.id">
                                        <mat-tab-group mat-stretch-tabs id="tab-session"
                                            (selectedTabChange)="changeViewByTabInfoOrder($event.index)"
                                            [selectedIndex]="selectedTabInfoOrderIndex">
                                            <mat-tab label="Itens da OS">
                                                <ng-template mat-tab-label>
                                                    <mat-icon class="mr-8">assignment_turned_in</mat-icon>
                                                    Itens da OS
                                                </ng-template>

                                                <button mat-stroked-button aria-label="detalhes" title="Adicionar Item"
                                                    *ngIf="useWebserviceDB == true || useWebserviceLabchekap == true
                                                    || useWebserviceLabAlvaro == true"
                                                    (click)="openDialogDbDiagnostic(1)" color="primary">
                                                    {{useWebserviceDB == true ? 'DB Diagnóstico' :
                                                    useWebserviceLabchekap ==
                                                    true ? 'Labchecap' : useWebserviceLabAlvaro == true ? 'LabAlvaro' : ''}}
                                                </button>


                                                <mat-table *ngIf="!isNewItemOs" #table [dataSource]="osItensList"
                                                    class="data-table itens" style="width: 100%; ">
                                                    <!-- <button id="addItem" mat-raised-button class=" mr-12 "
                                                (click)="isNewItemOs = !isNewItemOs" *ngIf="isNewItemOs">
                                                voltar
                                            </button> -->
                                                    <!-- patient Column -->
                                                    <ng-container matColumnDef="orderItem_name">
                                                        <mat-header-cell *matHeaderCellDef>
                                                            Item - Descrição</mat-header-cell>
                                                        <mat-cell *matCellDef="let orderItem">
                                                            <p class="text-truncate">{{orderItem.procedureName}}</p>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <ng-container matColumnDef="orderItem_code">
                                                        <mat-header-cell *matHeaderCellDef>
                                                            Item - Código</mat-header-cell>
                                                        <mat-cell *matCellDef="let orderItem">
                                                            <p class="text-truncate">{{orderItem.procedureCode}}</p>
                                                        </mat-cell>
                                                    </ng-container>


                                                    <ng-container matColumnDef="orderItem_quantity">
                                                        <mat-header-cell *matHeaderCellDef>
                                                            Qtd</mat-header-cell>
                                                        <mat-cell *matCellDef="let orderItem">
                                                            <p class="text-truncate">{{orderItem.quantity}}</p>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <ng-container
                                                        matColumnDef="orderItem_performer_professional_person_name">
                                                        <mat-header-cell *matHeaderCellDef>
                                                            Profissional</mat-header-cell>
                                                        <mat-cell *matCellDef="let orderItem">
                                                            <p class="text-truncate">
                                                                {{orderItem.performerName}}</p>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <ng-container matColumnDef="orderItem_prodCod">
                                                        <mat-header-cell *matHeaderCellDef>
                                                            Item - Código</mat-header-cell>
                                                        <mat-cell *matCellDef="let orderItem">
                                                            <p class="text-truncate">{{orderItem.id}}</p>
                                                        </mat-cell>
                                                    </ng-container>


                                                    <ng-container matColumnDef="orderItem_date">
                                                        <mat-header-cell *matHeaderCellDef>
                                                            Data </mat-header-cell>
                                                        <mat-cell *matCellDef="let orderItem">
                                                            <p class="text-truncate">{{orderItem.date |
                                                                amDateFormat:'DD/MM/YYYY'}}
                                                            </p>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <ng-container matColumnDef="orderItem_total">
                                                        <mat-header-cell *matHeaderCellDef
                                                            style="text-align: right;">R$</mat-header-cell>
                                                        <mat-cell *matCellDef="let order" style="text-align: right;">
                                                            <p class="text-truncate">{{order.value | currency: ' '}}</p>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <ng-container matColumnDef="gloss">
                                                        <mat-header-cell *matHeaderCellDef
                                                            style="text-align: right;"></mat-header-cell>
                                                        <mat-cell *matCellDef="let order" style="text-align: right;">
                                                            <p matTooltip="Glosa" class="text-truncate"
                                                                style="color: red;" *ngIf="order.gloss">
                                                                {{order.gloss ? 'G' : ''}}
                                                            </p>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <ng-container matColumnDef="order_item_percent">
                                                        <mat-header-cell *matHeaderCellDef
                                                            style="text-align: right;"></mat-header-cell>
                                                        <mat-cell *matCellDef="let order" style="text-align: right;">
                                                            <p class="text-truncate"
                                                                id="operational-reception-os-show-percent-performer-edit-form_it">
                                                                {{order.participationType == '$' ?
                                                                order.participationType :
                                                                ''}} {{ order.participationValue | currency: ' '}}
                                                                {{order.participationType == '%' ?
                                                                order.participationType :
                                                                ''}}</p>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <ng-container matColumnDef="orderItem_orderItemTiss_status">
                                                        <mat-header-cell *matHeaderCellDef
                                                            style="text-align: right;">Status</mat-header-cell>
                                                        <mat-cell *matCellDef="let order" style="text-align: right;">
                                                            <p class="text-truncate">{{order.status }}</p>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <!-- Buttons Column -->
                                                    <ng-container matColumnDef="button">
                                                        <mat-header-cell *matHeaderCellDef>
                                                            <button mat-icon-button aria-label="detalhes"
                                                                title="Adicionar Item" [disabled]="order.status === '2'"
                                                                (click)="detailsOrderItem({order:order.id})"
                                                                color="primary">
                                                                <mat-icon>
                                                                    add
                                                                </mat-icon>
                                                            </button>

                                                        </mat-header-cell>
                                                        <mat-cell *matCellDef="let orderItem">

                                                            <button id="schedule-search" mat-icon-button
                                                                aria-label="terceiros" title="terceiros" color="primary"
                                                                (click)="addThirdParty(orderItem)">
                                                                <mat-icon>title</mat-icon>
                                                            </button>

                                                            <button id="schedule-search" mat-icon-button
                                                                aria-label="detalhes" color="primary"
                                                                (click)="detailsOrderItem(orderItem)">
                                                                <mat-icon>search</mat-icon>
                                                            </button>

                                                            <button id="schedule-search" mat-icon-button
                                                                aria-label="apagar"
                                                                [disabled]="disableDeleteOrderItem && orderItem.statusBilling == 'BILLED'"
                                                                color="warn" (click)="exclusionMotive(orderItem)">
                                                                <mat-icon>delete_forever</mat-icon>
                                                            </button>

                                                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                                                (click)="$event.preventDefault(); $event.stopPropagation(); ">
                                                                <mat-icon>more_vert</mat-icon>
                                                            </button>
                                                            <mat-menu #menu="matMenu">
                                                                <button mat-menu-item
                                                                    (click)="onAction('COPY', orderItem.id    )">
                                                                    <mat-icon>file_copy</mat-icon>
                                                                    <span>Duplicar item</span>
                                                                </button>
                                                                <button mat-menu-item *ngIf="orderItem.status == null"
                                                                    (click)="cancelOrderItem(orderItem.id)">
                                                                    <mat-icon>not_interested</mat-icon>
                                                                    <span>Cancelar Item</span>
                                                                </button>
                                                                <button mat-menu-item
                                                                    *ngIf="orderItem.status != nullgit push"
                                                                    (click)="undoCancelOrderItem(orderItem.id)">
                                                                    <mat-icon>not_interested</mat-icon>
                                                                    <span>Desfazer Cancelamento</span>
                                                                </button>
                                                            </mat-menu>

                                                        </mat-cell>
                                                    </ng-container>

                                                    <mat-header-row
                                                        *matHeaderRowDef="displayedColumnsItensOs; sticky: true">
                                                    </mat-header-row>
                                                    <mat-row
                                                        *matRowDef="let row; columns: displayedColumnsItensOs;"></mat-row>
                                                    <!-- (dblclick)="detailsOrderItem(orderItem)" -->
                                                </mat-table>
                                                <section *ngIf="isNewItemOs" style="margin-top: 1px !important;">
                                                    <os-items #osItems [costCenterList]="costCenterList"
                                                        [insurance]="insurance"
                                                        [ControlSessionByParameterSystem]="ControlSessionByParameterSystem"
                                                        [subscription]="unsubscribeAll" [order]="order"
                                                        (emitUpdate)="update($event)" (emitAction)="action($event)"
                                                        (orderItemAdd)="addOrderItemToList($event)"
                                                        [orderItem]="orderItem">
                                                    </os-items>
                                                </section>
                                            </mat-tab>
                                            <mat-tab label="Autorização" [disabled]="disabledTabOrder">
                                                <ng-template mat-tab-label>

                                                    <mat-icon class="mr-8">vpn_key</mat-icon>
                                                    Autorização
                                                    <mat-icon
                                                        *ngIf="order.requeryAutorization && !order.orderAuthorization?.id"
                                                        class="ml-20" style="color: red;"
                                                        title="Existe procedimento que requer autorização.">report</mat-icon>
                                                    <!--requeryAutorization-->

                                                </ng-template>
                                                <ng-template matTabContent>
                                                    <cw-order-authorization [order]="order" [patientId]="patient.id"
                                                        (isNotAuth)="isNoAuth = $event"
                                                        (orderAuthorization)="orderAuthorization($event)">
                                                    </cw-order-authorization>

                                                </ng-template>

                                            </mat-tab>

                                            <mat-tab label="Token" [disabled]="disabledTabOrder || usageToken === '0'">
                                                <ng-template mat-tab-label>

                                                    <mat-icon class="mr-8">vpn_key</mat-icon>
                                                    Token
                                                </ng-template>
                                                <ng-template matTabContent>

                                                    <cw-authorization-token [iOrderId]="order.id" [iUserWebserviceSulAmerica]="userWebserviceSulAmerica"
                                                        [iOrderItemList]="osItensList" (emitUpdate)="update($event)"
                                                        style="margin-top: 6px;"></cw-authorization-token>

                                                </ng-template>

                                            </mat-tab>
                                            <mat-tab label="Informações da Guia" [disabled]="disabledTabOrder">
                                                <ng-template mat-tab-label>
                                                    <mat-icon class="mr-8">info</mat-icon>
                                                    Informações da Guia
                                                </ng-template>
                                                <ng-template matTabContent>
                                                    <order-tiss [order]="order"></order-tiss>

                                                </ng-template>
                                            </mat-tab>

                                            <mat-tab label="Dados  de Pagamento"
                                                [disabled]="isPaymentTabDisabled()">
                                                <ng-template mat-tab-label>
                                                    <mat-icon class="mr-8">payments</mat-icon>
                                                    Dados de Pagamento
                                                    <mat-icon
                                                        *ngIf="orderPayMissing != '0' && (order.insurance.paymentModel == 'P' || order.insurance.paymentModel == 'O')"
                                                        matTooltip="Possui pendência de pagamento"
                                                        class="infoPendecyPayment">
                                                        info
                                                    </mat-icon>
                                                </ng-template>


                                                <section *ngIf="!isDetailsPayment && !isOrderPayer">
                                                    <form [formGroup]="orderPayForm" class="w-100-p" autocomplete="off"
                                                        style="display: block!important;" fxLayout="column">


                                                        <div fxLayout="row" fxLayoutAlign="end center"
                                                            class="mt-10 mb-10 ml-12">

                                                            <div *ngIf="discountOS != null">
                                                                <h4 class="infoStatus warn">Pagando em Espécie fica por
                                                                    {{valueAfterDiscount | currency: 'R$'}} desconto de
                                                                    {{discountOS
                                                                    | currency: 'R$'}}.</h4>

                                                            </div>


                                                            <mat-form-field class="mr-12" style="margin-top: 10px;"
                                                                fxFlex="10" *ngIf="!progress">
                                                                <mat-label>Desconto </mat-label>
                                                                <input matInput name="discount" currencyMask
                                                                    [formControl]="discountControl"
                                                                    [options]="{ prefix: '', thousands: '.', decimal: ',', precision: 2}" />
                                                                <button *ngIf="typeDiscount == '1'" mat-icon-button
                                                                    matPrefix [disabled]="disableDeleteOrderPay"
                                                                    matTooltip="Mudar para percentual" mat-icon-button
                                                                    (click)="changeType('2')">
                                                                    R$
                                                                </button>
                                                                <button *ngIf="typeDiscount == '2'" mat-icon-button
                                                                    matPrefix [disabled]="disableDeleteOrderPay"
                                                                    matTooltip="Mudar para Dinheiro" mat-icon-button
                                                                    (click)="changeType('1')">
                                                                    %
                                                                </button>
                                                                <button mat-icon-button (click)="applyDiscount()"
                                                                    matSuffix [disabled]="disableDeleteOrderPay"
                                                                    matTooltip="Aplicar desconto">
                                                                    <mat-icon>check</mat-icon>
                                                                </button>
                                                            </mat-form-field>

                                                            <button matTooltip="salvar" id="edit" mat-stroked-button
                                                                class="mr-12" color="primary"
                                                                (click)="alterOrderPayer()" *ngIf="!progress">Informar
                                                                Dmed
                                                                <mat-icon>order_approve</mat-icon>

                                                            </button>

                                                            <button matTooltip="salvar" id="edit" mat-stroked-button
                                                                class="mr-12" color="primary" (click)="saveOrderPay()"
                                                                *ngIf="!progress">Salvar Pagamento
                                                                <mat-icon>backup</mat-icon>

                                                            </button>

                                                            <div fxLayout="row" fxLayoutAlign="space-evenly center"
                                                                color="primary" *ngIf="progress">
                                                                <mat-spinner [diameter]="20" class="mr-8"></mat-spinner>
                                                                <p>Salvando...</p>
                                                            </div>




                                                        </div>



                                                        <mat-divider></mat-divider> <br>

                                                        <div fxLayout="row" fxFlex="100" fxLayoutGap="5">

                                                            <mat-form-field appearance="outline" fxFlex="40">
                                                                <mat-label>Forma de Pagamento </mat-label>
                                                                <mat-select
                                                                    id="operational-reception-order_pay-payType-edit-form_cs"
                                                                    name="payType" formControlName="payType" required>
                                                                    <mat-option [value]="null">
                                                                        Selecione
                                                                    </mat-option>
                                                                    <mat-option *ngFor="let payType of payTypeList"
                                                                        [value]="payType">
                                                                        {{payType.name}}
                                                                    </mat-option>
                                                                </mat-select>

                                                            </mat-form-field>

                                                            <mat-form-field appearance="outline" fxFlex="12">
                                                                <mat-label>Data de Lançamento</mat-label>
                                                                <input autocomplete="off" matInput
                                                                    [matDatepicker]="datePay" placeholder="Validade"
                                                                    formControlName="date" />
                                                                <mat-datepicker-toggle id="datePay" matSuffix
                                                                    [for]="datePay">
                                                                </mat-datepicker-toggle>
                                                                <mat-datepicker #datePay></mat-datepicker>
                                                                <mat-error
                                                                    *ngIf="orderPayForm.get('date').hasError('required')">
                                                                    Campo é obrigatório
                                                                </mat-error>
                                                            </mat-form-field>

                                                            <mat-form-field appearance="outline" fxFlex="20"
                                                                *ngIf="togglePayType == false">
                                                                <mat-label>Quantidade de Parcelas </mat-label>
                                                                <input
                                                                    id="operational-reception-order_pay-parcel-edit-form_it"
                                                                    matInput maxlength="" name="parcel"
                                                                    formControlName="parcel" required
                                                                    [pattern]="patterQuatityParcel">


                                                                <mat-error
                                                                    *ngIf="orderPayForm.get('parcel').hasError('required')">
                                                                    O campo é obrigatório
                                                                </mat-error>

                                                                <mat-error
                                                                    *ngIf="orderPayForm.get('parcel').hasError('maxlength')">
                                                                    Campo excedeu caracteres
                                                                </mat-error>


                                                                <mat-error
                                                                    *ngIf="orderPayForm.get('parcel').hasError('pattern')">
                                                                    Valor informado excede a quantidade permitida : {{
                                                                    orderPayForm.controls['payType'].value.splitMax }}
                                                                </mat-error>

                                                            </mat-form-field>



                                                            <mat-form-field appearance="outline" fxFlex="20">
                                                                <mat-label>Valor </mat-label>
                                                                <input
                                                                    id="operational-reception-order_pay-value-edit-form_it"
                                                                    currencyMask
                                                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2}"
                                                                    matInput name="value" formControlName="value"
                                                                    required>


                                                                <mat-error
                                                                    *ngIf="orderPayForm.get('value').hasError('required')">
                                                                    O campo é obrigatório
                                                                </mat-error>

                                                                <mat-error
                                                                    *ngIf="orderPayForm.get('value').hasError('maxlength')">
                                                                    Campo excedeu caracteres
                                                                </mat-error>


                                                                <mat-error
                                                                    *ngIf="orderPayForm.get('value').hasError('pattern')">
                                                                    Campo numérico
                                                                </mat-error>

                                                            </mat-form-field>
                                                            <!-- 
                                                    <mat-form-field appearance="outline" fxFlex="8" class="mr-8">
                                                        <mat-label>Desconto</mat-label>
                                                        <input *ngIf="type == '1'" matInput name="discount" required
                                                            formControlName="discount" currencyMask
                                                            [options]="{ prefix: ' ', thousands: '.', decimal: ',', precision: 2}" />
                                                        <input *ngIf="type == '2'" matInput name="discount" required
                                                            formControlName="discount" />
                                                        <button *ngIf="type == '2'" mat-button matPrefix mat-icon-button (click)="changeType('1')">
                                                        <p matTooltip="Percentual">%</p>
                                                    </button>
                                                    <button *ngIf="type == '1'" mat-button matPrefix mat-icon-button (click)="changeType('2')">
                                                        <p matTooltip="Monetário">R$</p>
                                                    </button>
                                                    </mat-form-field> -->




                                                            <mat-form-field appearance="outline" fxFlex="20">
                                                                <mat-label>Saldo </mat-label>
                                                                <input
                                                                    id="operational-reception-order_pay-value-edit-form_it"
                                                                    matInput maxlength="" readonly name="missing"
                                                                    currencyMask
                                                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', precision: 2}"
                                                                    maxlength="10" matInput formControlName="missing"
                                                                    type="text" />
                                                            </mat-form-field>


                                                        </div>

                                                        <div>
                                                            <mat-form-field appearance="outline" fxFlex="100">
                                                                <mat-label>Identificador da Transação</mat-label>
                                                                <input matInput formControlName="transactionIdentifier">
                                                            </mat-form-field>
                                                        </div>

                                                        <div>
                                                            <mat-form-field appearance="outline" fxFlex="100">
                                                                <mat-label>Observação</mat-label>
                                                                <input matInput name="notes" matInput
                                                                    formControlName="notes" type="text" />
                                                            </mat-form-field>
                                                        </div>

                                                    </form>

                                                    <mat-table #tablePay [dataSource]="osPayList"
                                                        class="data-table scheduleTable" style="height: 55vh;"
                                                        fusePerfectScrollbar>
                                                        <ng-container matColumnDef="orderPay.payType.name">
                                                            <mat-header-cell *matHeaderCellDef>
                                                                Forma de Pagamento</mat-header-cell>
                                                            <mat-cell *matCellDef="let orderPay">
                                                                <p class="text-truncate">{{orderPay.payType?.name}}</p>
                                                            </mat-cell>
                                                        </ng-container>

                                                        <ng-container matColumnDef="orderPay.brand.name">
                                                            <mat-header-cell *matHeaderCellDef>
                                                                Bandeira do Cartão</mat-header-cell>
                                                            <mat-cell *matCellDef="let orderPay">
                                                                <p class="text-truncate">{{orderPay.brand?.name}}</p>
                                                            </mat-cell>
                                                        </ng-container>

                                                        <ng-container matColumnDef="orderPay.date">
                                                            <mat-header-cell *matHeaderCellDef>
                                                                Data de Lançamento</mat-header-cell>
                                                            <mat-cell *matCellDef="let orderPay">
                                                                <p class="text-truncate">{{orderPay.date |
                                                                    amDateFormat:'DD/MM/YYYY'}}
                                                                </p>
                                                            </mat-cell>
                                                        </ng-container>

                                                        <ng-container matColumnDef="orderPay.value">
                                                            <mat-header-cell *matHeaderCellDef>
                                                                Valor</mat-header-cell>
                                                            <mat-cell *matCellDef="let orderPay">
                                                                <p class="text-truncate">{{orderPay.value | currency:
                                                                    'R$'}}
                                                                </p>
                                                            </mat-cell>
                                                        </ng-container>


                                                        <ng-container matColumnDef="orderPay.receptDate">
                                                            <mat-header-cell *matHeaderCellDef>
                                                                Data de Recebimento</mat-header-cell>
                                                            <mat-cell *matCellDef="let orderPay">
                                                                <p class="text-truncate">{{orderPay.receptDate |
                                                                    amDateFormat:'DD/MM/YYYY'}}
                                                                </p>
                                                            </mat-cell>
                                                        </ng-container>

                                                        <!-- Buttons Column -->
                                                        <ng-container matColumnDef="button">
                                                            <mat-header-cell *matHeaderCellDef>
                                                                <!-- pagamento detalhado retirado a pedido de anagÊ -->
                                                                <!-- <mat-icon style="cursor:pointer;" color="primary"
                                                            (click)="orderPayDetail(null)" matTooltip="Adicionar">add
                                                        </mat-icon> -->
                                                            </mat-header-cell>
                                                            <mat-cell *matCellDef="let orderPay">

                                                                <button id="schedule-search" mat-icon-button
                                                                    aria-label="detalhes"
                                                                    (click)="orderPayDetail(orderPay.id)">
                                                                    <mat-icon>search</mat-icon>
                                                                </button>

                                                                <button id="schedule-search" mat-icon-button
                                                                    aria-label="apagar"
                                                                    (click)="deleteOrderPay(orderPay.id)"
                                                                    [disabled]="disableDeleteOrderPay">
                                                                    <mat-icon>delete_forever</mat-icon>
                                                                </button>

                                                            </mat-cell>
                                                        </ng-container>

                                                        <mat-header-row
                                                            *matHeaderRowDef="displayedColumnsDadosPagtos; sticky: true">
                                                        </mat-header-row>
                                                        <mat-row
                                                            *matRowDef="let row; columns: displayedColumnsDadosPagtos;"
                                                            (dblclick)="orderPayDetail(row.id)">
                                                        </mat-row>
                                                    </mat-table>
                                                </section>

                                                <section *ngIf="isDetailsPayment && !isOrderPayer">
                                                    <order-pay [order]="order" [orderPayId]="orderPayId"
                                                        (emitAction)="action($event)" (updatePayList)="getOrderPays()">
                                                    </order-pay>
                                                </section>

                                                <section *ngIf="isOrderPayer && !isOrderPayerList">
                                                    <cwg-order-payer [order]="order" [orderPayer]="orderPayerDetail"
                                                        (isOrderPayerList)="getIsOrderPayerList($event)">
                                                    </cwg-order-payer>
                                                </section>

                                                <section *ngIf="isOrderPayer && isOrderPayerList">
                                                    <cwg-order-payer-list [order]="order"
                                                        (orderPayerDetail)="getOrderPayerDetail($event)"
                                                        (newOrderPayer)="newOrderPayer($event)"
                                                        (isOrderPayer)="isOrderPayerEmmit($event)">
                                                    </cwg-order-payer-list>
                                                </section>
                                            </mat-tab>
                                            <!-- [disabled]="disabledTabOrder" -->
                                            <mat-tab label="Dados de Faturamento">
                                                <ng-template mat-tab-label>
                                                    <mat-icon class="mr-8">attach_money</mat-icon>
                                                    Dados de Faturamento
                                                </ng-template>

                                                <br><br>

                                                <mat-tab-group mat-stretch-tabs>

                                                    <mat-tab label="Pendência">



                                                        <cwg-order-pending (updateOrder)="updateOrder(order.id)"
                                                            [order]="order"></cwg-order-pending>


                                                    </mat-tab>

                                                    <mat-tab label=" Informações de Alta">

                                                        <cwg-order-closure [order]="order"></cwg-order-closure>

                                                    </mat-tab>

                                                </mat-tab-group>

                                                <!-- *ngIf="isProcedure" TODO verificar com barauna -->
                                                <!-- <div fxLayout="row" class="w-100-p">
                                            <cwg-order-closure [order]="order"></cwg-order-closure>
                                        </div> -->

                                                <!-- *ngIf="isProcedure" TODO verificar com barauna -->
                                                <!-- <div fxLayout="row" class="w-100-p mt-3">
                                            <cwg-order-pending [order]="order"></cwg-order-pending>
                                        </div> -->
                                            </mat-tab>

                                            <!--mat-tab label="CID's">
                                        <cid-order></cid-order>
                                    </mat-tab-->

                                        </mat-tab-group>
                                    </section>
                                </mat-tab>
                                <mat-tab label="Funções">
                                    <app-functionsAttendance [patient]="patient"></app-functionsAttendance>
                                </mat-tab>
                            </mat-tab-group>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
